module.exports = __webpack_public_path__ + "img/downloadNowzh.f9a53963.png";